// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-global-search {
  position: relative;
  max-width: 650px;
  font-family: "Manrope-Regular", "Segoe UI", sans-serif;
}

.nav-global-search__group {
  flex-wrap: nowrap !important;
}

.nav-global-search__icon {
  min-width: 48px;
  justify-content: center;
  border: 1px solid #9dafcf !important;
  border-right: 0 !important;
  border-radius: 10px 0 0 10px !important;
  background: #fff !important;
  color: #263f86 !important;
}

.nav-global-search .form-control {
  min-width: 0;
  min-height: 44px;
  border: 1px solid #9dafcf !important;
  border-right: 0 !important;
  border-left: 0 !important;
  color: #172033;
  font-size: 14px !important;
}

.nav-global-search .form-control::placeholder { color: #667085; opacity: 1; }
.nav-global-search .form-control:focus {
  border-color: #3656a5 !important;
  box-shadow: inset 0 0 0 1px #3656a5 !important;
}

.nav-global-search .btn {
  min-width: 86px;
  min-height: 44px;
  border: 1px solid #263f86 !important;
  border-radius: 0 10px 10px 0 !important;
  background: #263f86 !important;
  color: #fff;
  font-size: 13px;
  font-weight: 750;
}

.nav-global-search .btn:hover:not(:disabled) { background: #1e3474 !important; }
.nav-global-search .btn:disabled { opacity: .72; }

.nav-global-search__results {
  position: absolute;
  z-index: 1080;
  top: calc(100% + 8px);
  right: 0;
  left: 0;
  max-height: min(430px, 65vh);
  overflow-y: auto;
  padding: 7px;
  border: 1px solid #d7e0ed;
  border-radius: 13px;
  background: #fff;
  box-shadow: 0 18px 42px rgba(15, 23, 42, .16);
}

.nav-global-search__result {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  width: 100%;
  padding: 11px;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: #172033;
  text-align: left;
}

.nav-global-search__result:hover,
.nav-global-search__result:focus-visible {
  background: #eef2ff;
}

.nav-global-search__result-badge {
  flex: 0 0 auto;
  margin-top: 1px;
  padding: 4px 7px;
  border-radius: 999px;
  background: #e7edff;
  color: #263f86;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: .04em;
  text-transform: uppercase;
}

.nav-global-search__result-copy {
  display: block;
  min-width: 0;
}

.nav-global-search__result-copy strong {
  display: block;
  overflow: hidden;
  color: #172554;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nav-global-search__result-copy small {
  display: block;
  overflow: hidden;
  margin-top: 3px;
  color: #526079;
  font-size: 11px;
  line-height: 1.4;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.nav-global-search__status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-height: 72px;
  padding: 14px;
  color: #526079;
  font-size: 12px;
  font-weight: 650;
  text-align: center;
}

@media (max-width: 991.98px) {
  .nav-global-search {
    width: 100% !important;
    max-width: none;
    margin: 12px 0 !important;
  }
}

@media (max-width: 480px) {
  .nav-global-search__icon { min-width: 42px; }
  .nav-global-search .btn { min-width: 72px; padding-right: 10px; padding-left: 10px; }
  .nav-global-search .form-control { font-size: 12px !important; }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/NavMenu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,oCAAoC;EACpC,0BAA0B;EAC1B,uCAAuC;EACvC,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,oCAAoC;EACpC,0BAA0B;EAC1B,yBAAyB;EACzB,cAAc;EACd,0BAA0B;AAC5B;;AAEA,gDAAgD,cAAc,EAAE,UAAU,EAAE;AAC5E;EACE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,uCAAuC;EACvC,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,+CAA+C,8BAA8B,EAAE;AAC/E,mCAAmC,YAAY,EAAE;;AAEjD;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,OAAO;EACP,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,eAAe;IACf,yBAAyB;EAC3B;AACF;;AAEA;EACE,2BAA2B,eAAe,EAAE;EAC5C,0BAA0B,eAAe,EAAE,mBAAmB,EAAE,kBAAkB,EAAE;EACpF,mCAAmC,0BAA0B,EAAE;AACjE","sourcesContent":[".nav-global-search {\n  position: relative;\n  max-width: 650px;\n  font-family: \"Manrope-Regular\", \"Segoe UI\", sans-serif;\n}\n\n.nav-global-search__group {\n  flex-wrap: nowrap !important;\n}\n\n.nav-global-search__icon {\n  min-width: 48px;\n  justify-content: center;\n  border: 1px solid #9dafcf !important;\n  border-right: 0 !important;\n  border-radius: 10px 0 0 10px !important;\n  background: #fff !important;\n  color: #263f86 !important;\n}\n\n.nav-global-search .form-control {\n  min-width: 0;\n  min-height: 44px;\n  border: 1px solid #9dafcf !important;\n  border-right: 0 !important;\n  border-left: 0 !important;\n  color: #172033;\n  font-size: 14px !important;\n}\n\n.nav-global-search .form-control::placeholder { color: #667085; opacity: 1; }\n.nav-global-search .form-control:focus {\n  border-color: #3656a5 !important;\n  box-shadow: inset 0 0 0 1px #3656a5 !important;\n}\n\n.nav-global-search .btn {\n  min-width: 86px;\n  min-height: 44px;\n  border: 1px solid #263f86 !important;\n  border-radius: 0 10px 10px 0 !important;\n  background: #263f86 !important;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 750;\n}\n\n.nav-global-search .btn:hover:not(:disabled) { background: #1e3474 !important; }\n.nav-global-search .btn:disabled { opacity: .72; }\n\n.nav-global-search__results {\n  position: absolute;\n  z-index: 1080;\n  top: calc(100% + 8px);\n  right: 0;\n  left: 0;\n  max-height: min(430px, 65vh);\n  overflow-y: auto;\n  padding: 7px;\n  border: 1px solid #d7e0ed;\n  border-radius: 13px;\n  background: #fff;\n  box-shadow: 0 18px 42px rgba(15, 23, 42, .16);\n}\n\n.nav-global-search__result {\n  display: flex;\n  align-items: flex-start;\n  gap: 11px;\n  width: 100%;\n  padding: 11px;\n  border: 0;\n  border-radius: 9px;\n  background: transparent;\n  color: #172033;\n  text-align: left;\n}\n\n.nav-global-search__result:hover,\n.nav-global-search__result:focus-visible {\n  background: #eef2ff;\n}\n\n.nav-global-search__result-badge {\n  flex: 0 0 auto;\n  margin-top: 1px;\n  padding: 4px 7px;\n  border-radius: 999px;\n  background: #e7edff;\n  color: #263f86;\n  font-size: 9px;\n  font-weight: 800;\n  letter-spacing: .04em;\n  text-transform: uppercase;\n}\n\n.nav-global-search__result-copy {\n  display: block;\n  min-width: 0;\n}\n\n.nav-global-search__result-copy strong {\n  display: block;\n  overflow: hidden;\n  color: #172554;\n  font-size: 13px;\n  font-weight: 800;\n  line-height: 1.35;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.nav-global-search__result-copy small {\n  display: block;\n  overflow: hidden;\n  margin-top: 3px;\n  color: #526079;\n  font-size: 11px;\n  line-height: 1.4;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.nav-global-search__status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 9px;\n  min-height: 72px;\n  padding: 14px;\n  color: #526079;\n  font-size: 12px;\n  font-weight: 650;\n  text-align: center;\n}\n\n@media (max-width: 991.98px) {\n  .nav-global-search {\n    width: 100% !important;\n    max-width: none;\n    margin: 12px 0 !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .nav-global-search__icon { min-width: 42px; }\n  .nav-global-search .btn { min-width: 72px; padding-right: 10px; padding-left: 10px; }\n  .nav-global-search .form-control { font-size: 12px !important; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
